import Service from '@ember/service';

import { cached, tracked } from '@glimmer/tracking';

import { concat } from 'rise-ui/utils/array.js';
import { collect, truth } from 'rise-ui/utils/object/computed/array.js';
import { complex, labelOrConfig, refreshes } from 'rise-ui/utils/query-params.js';

// Map from service API param identifiers to their URL query-param keys
export const qp = {
  version: 'v',
  memory: 'mem',
  style: 'style',
  locations: 'lo',
  items: 'it',
  modelRuns: 'mr',
  defaultDates: 'dd',
  itemDates: 'id',
  modelRunDates: 'md',
};

// FIXME: This is not very composable
const crefresh = p => labelOrConfig(p, refreshes(complex()));

export const qpRoute = {
  version: refreshes(qp.version),
  memory: crefresh(qp.memory),
  style: crefresh(qp.style),
  locations: crefresh(qp.locations),
  items: crefresh(qp.items),
  modelRuns: crefresh(qp.modelRuns),
  defaultDates: crefresh(qp.defaultDates),
  itemDates: crefresh(qp.itemDates),
  modelRunDates: crefresh(qp.modelRunDates),
};

export const queryParamKeys = Object.keys(qp);
export const queryParams = Object.values(qp);

export const timeSeriesRouteQueryParams
  = queryParamKeys.reduce((params, key) => {
    return { ...params, ...qpRoute[key] };
  }, {});

export default class TimeSeriesParamsService extends Service {
  @tracked params = {};

  // Set specified params as key/value hash
  setParams(params) {
    this.params = !params ? {} : {
      ...this.params,
      ...queryParams.reduce((newParams, name) => {
        if (name in params) {
          newParams[name] = params[name];
        }
        return newParams;
      }, {}),
    };
  }
  @collect(`params.${qp.locations}`) locations;
  @collect(`params.${qp.items}`) items;
  @collect(`params.${qp.modelRuns}`) modelRuns;
  @truth('locations') hasLocation;
  @truth('items') hasItem;
  @truth('modelRuns') hasModelRun;
  @collect(`params.${qp.defaultDates}`) defaultDates;
  @cached get itemDates() {
    let itemDates = this.params[qp.itemDates] || {};
    Object.keys(itemDates).forEach(itemId => {
      itemDates[itemId] = concat(itemDates[itemId]);
    });
    return itemDates;
  }
  @cached get modelRunDates() {
    let modelRunDates = this.params[qp.modelRunDates] || {};
    Object.keys(modelRunDates).forEach(modelRunId => {
      modelRunDates[modelRunId] = concat(modelRunDates[modelRunId]);
    });
    return modelRunDates;
  }
}
